<template>
    <!-- component -->
    <div>
        <div class="h-screen">
            <Headers />
            <main
                class="flex flex-col flex-grow md:ml-0 transition-all duration-150 ease-in min-h-screen bg-background max-w-full"
            >
                <div class="flex flex-col w-[90%] mx-auto">
                    <Title :pageTitle="$route.name" class="mb-2 mt-[90px]" />
                    <router-view></router-view>
                </div>
                <Footers />
            </main>
        </div>
    </div>
</template>
<script>
import Headers from "../../components/Layout/Header/Headers.vue";
import SideNav from "../../components/Layout/SideNav/SideNav.vue";
import Footers from "../../components/Layout/Footer/Footers.vue";
import Title from "../../components/Layout/Header/Title.vue";
export default {
    components: { Headers, SideNav, Footers, Title },
};
</script>
